import React, {useState, useEffect, useRef} from 'react';
import _ from "lodash";
import cx from "classnames";
import dateformat from "dateformat";
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';
import storyboardRoleService from 'services/storyboardRoles.service';
import styles from './../fields.module.scss';

export default function CustomFieldItem ({onClick, onDelete, customField, fieldSelected, deletingId, storyboard, checkWorkspaceSettings}) {
  const fieldNameRef = useRef(null);
  const [width, setWidth] = useState(0);

  const RenderIcon = ( {fieldType} ) => {
    switch (fieldType) {
      case 'string_field':
        return <i className='cleverstory-text-layer'/>
          
      case 'list_field':
        return <i className='cleverstory-list'/>
          
      case 'number_field':
        return <i className='cleverstory-hash'/>
          
      case 'boolean_field':
        return <i className='cleverstory-checkbox'/>
          
      default:
        return <i className='cleverstory-list'/>
    }
  }

  useEffect(() => {
    if (fieldNameRef.current) {
      setWidth(fieldNameRef.current.getBoundingClientRect().width);
    }

    const handleResize = () => {
      if (fieldNameRef.current) {
        setWidth(fieldNameRef.current.getBoundingClientRect().width);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className={cx(styles.customField, {[styles.customFieldBackground] : fieldSelected, [styles.deleteAnimation]: deletingId === customField.id}, {[styles.disabled] : !checkWorkspaceSettings() && !storyboardRoleService.canEditStoryboard(storyboard)})} >
      <div className={styles.fieldRow} onClick={onClick}>
        <span className={styles.fieldName} ref={fieldNameRef}>
          <RenderIcon fieldType={_.get(customField, 'type', null)} />
          <TruncatedTextWithTooltip content={customField.name} className={cx(styles.name, {[styles.nameSelected] : fieldSelected})} maxWidth={width - 80} placement='top'/>
          {
            customField.source === "PAPERFLITE" ? 
            <span className={styles.pflogo}><i className={cx(styles.logo, 'cleverstory-paperflite-logo')} /></span>:
            <span className={styles.pflogo}></span>
          }
        </span>
        <span className={styles.modifiedDate}> 
          Updated on : {dateformat(customField ? customField.modifiedDate : null, 'dd mmm yyyy')} 
          <span className={cx(styles.deleteField)}><i className={cx('cleverstory-trash')} onClick={onDelete}/></span>
        </span>
      </div>
    </div>
  )
}